import { useQuery } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { getAllPlansList } from 'api/auth.api';

export const useGetAllPlans = () => {
  const toast = useToast();

  return useQuery({
    queryKey: ['plans-list'],
    queryFn: getAllPlansList,

    select: (res) => res?.data?.result || [],
  });
};
